const ZIP_CODE_KEY = 'veer-theme-saved-zip';

export const saveZip = (zip) => {
  try {
    window.localStorage.setItem(ZIP_CODE_KEY, zip);
  } catch (error) {
    console.warn(error);
  }
};

export const getZip = () => {
  try {
    return window.localStorage.getItem(ZIP_CODE_KEY);
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const isValidZip = (zip) => /\d{5}/.test(zip) || /[a-z]\d[a-z] ?\d[a-z]\d/i.test(zip) || /[a-z]\d[a-z]/i.test(zip);

export const zipCountry = (zip) => /[a-z]\d[a-z] ?\d[a-z]\d/i.test(zip) || /[a-z]\d[a-z]/i.test(zip) ? "CA" : "US";
